module.exports = __webpack_public_path__ + "6776403cd91f8ae79a3d5b8d6d765afb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/sponsors/landsbankinn.jpg
 ** module id = 379
 ** module chunks = 0
 **/